
import Vue from 'vue';
import Component from 'vue-class-component';
import MainView from '../components/MainView.vue';

@Component({
  name: 'MainPage',
  components: {
    MainView
  }
})
export default class MainPage extends Vue { };
